// extracted by mini-css-extract-plugin
module.exports = {"ScriptBox":"_1hdAkD4DeXVgtditdYmRns"};